import { Alert, Box } from '@mui/material';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const MessageDuplicate = () => {
  const { state } = useLocation();
  const isDuplicateOp = useMemo(() => state?.from === 'duplicate', [state]);

  return (
    isDuplicateOp &&
    state?.message && (
      <Box pb={2}>
        <Alert severity='info'>{state?.message}</Alert>
      </Box>
    )
  );
};

export default MessageDuplicate;
